import React, { FunctionComponent, useCallback, useState } from 'react';

import { useDispatch } from 'react-redux';
import { updateTaskSimple } from '../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { taskSimpleSelectors } from '../../../../../../app/resource/task-simple/task-simple.selectors';
import { ITaskSimple } from '../../../../../../app/resource/task-simple/task-simple.types';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';
import { ILabelsProps } from './types';
import moment from 'moment';
import { FaLock } from 'react-icons/fa';
import { labelSelectors } from '../../../../../../app/resource/label/label.selectors';

export const Labels: FunctionComponent<ILabelsProps> = ({ labelIds, taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId) as ITaskSimple;
  const dispatch = useDispatch();
  const [loaderTaskId, setLoaderTaskId] = useState('');
  const handleStatus = useCallback(
    (e, id) => {
      e.stopPropagation();
      setLoaderTaskId(id);
      const updatedTask = {
        status: task.status === '1' ? '0' : '1',
      };

      dispatch(updateTaskSimple(task.id, updatedTask));
    },
    [dispatch, task.id, task.status],
  );

  const labels = useSelectWithParams(labelSelectors.selectResourcesById, labelIds || []);
  return (
    <div className="card-header" style={{ justifyContent: 'space-between' }}>
      <div className="blueGray f-1 card-date flex aic" style={{ flexWrap: 'wrap' }}>
        {labels &&
          labels.map(
            (label) =>
              label && (
                <span
                  key={`${taskId}-label[${label.id}]`}
                  className="team-badge"
                  style={{ backgroundColor: label.color, margin: '0 5px 5px 0' }}
                />
              ),
          )}
      </div>

      {loaderTaskId !== task.id && (
        <div
          className="checklist-checkbox flex aic m-0"
          onClick={!task.isLocked ? (e) => handleStatus(e, task.id) : undefined}
        >
          {task && task.completedAt && moment(task.completedAt).isValid() ? (
            <label className="mr-1 blueGray" style={{ position: 'relative', bottom: '-10px', fontSize: '12px' }}>
              {moment(task.completedAt).format('MM/DD')}
            </label>
          ) : (
            <br></br>
          )}
          {task && task.isLocked ? (
            <FaLock className="darkGray" size={15} />
          ) : (
            <>
              <input type="checkbox" id={`checkBox-${task.id}`} checked={task.status === '1'} readOnly />
              <label htmlFor={`checkBox-${task.id}`}></label>
            </>
          )}
        </div>
      )}
    </div>
  );
};
